export const CUSTOM_SERVER_DATA_ID = '__SBIZ_CUSTOM_SERVER_DATA__';
export const MOCK_USER_AUTH_COOKIE_KEY = 'MOCK_USER_AUTH';
// GTM Container ID
export const GTM_CONTAINER_ID = 'GTM-TSVZDWK';
